import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Project } from 'services/action';

import { Page, Button } from 'ui/components';

import { FormInput } from './component/form';

const initialState = {
  form: null,
};

const CreateScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ form }, setState] = React.useState(initialState);

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      ...form,
    };

    const submit = await Dispatch(Project.$create(payload));

    if (submit?.message === 'success') {
      History.replace(`/master/project`);
    }
  };

  return (
    <Page type="form" className="col-md-8 bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Buat Project" className="border-bottom" />

      <Page.Body className="d-block px-3">
        <FormInput onInputChange={$handleFormChange} />
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/master/project`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
